module.exports = __webpack_public_path__ + "img/live_bbin.f041e2ee.png";